import { render, staticRenderFns } from "./CardCollect.modal.vue?vue&type=template&id=06d6ae0d&"
import script from "./CardCollect.modal.vue?vue&type=script&lang=js&"
export * from "./CardCollect.modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports